import { render, staticRenderFns } from "./AccessGroupList.vue?vue&type=template&id=74571ace"
import script from "./AccessGroupList.vue?vue&type=script&lang=js"
export * from "./AccessGroupList.vue?vue&type=script&lang=js"
import style0 from "./AccessGroupList.vue?vue&type=style&index=0&id=74571ace&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74571ace')) {
      api.createRecord('74571ace', component.options)
    } else {
      api.reload('74571ace', component.options)
    }
    module.hot.accept("./AccessGroupList.vue?vue&type=template&id=74571ace", function () {
      api.rerender('74571ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccessControl/AccessGroupList.vue"
export default component.exports